<template>
  <div class="">
    <div class="row">
      <div class="col-md-12 col-sm-8">
        <div class="card card-default widget animated">
          <div class="card-heading">
            <!--Viewing-->
            <div class="OrganizationViewing" v-show="!isEditing">
              <div class="form-group col-md-5">
                <p style="font-size:35px">{{org.name}}</p>
                <p>{{org.description}}</p>
                <p>Org ID: {{org['.key']}}</p>
                <p>Email Alerts: {{org.emails ? 'Enabled' : 'Disabled'}}</p>
                <p>Chat: {{org.chat ? 'Enabled' : 'Disabled'}}</p>
                <p>Inventory: {{org.inventory ? 'Enabled' : 'Disabled'}}</p>
                <br>
                <button v-on:click="edit" type="button" class="btn btn-default form-group">Edit</button>
                <button type="button" data-toggle="modal" data-target="#showQRCodeModal" class="btn btn-info form-group">ShowQRCode</button>
              </div>
            </div>
            <!--Editing-->
            <div class="OrganizationEditing col-md-5" v-show="isEditing">
              <form-text ref="orgname" styler="font-size:35px"  label="Organization Name" name="organizationname" v-model="orgEdit.name" validation="required"></form-text>
              <form-textarea ref="orgdescription" abel="Description" name="description" v-model="orgEdit.description"></form-textarea>
              <form-checkbox label="Email Alerts" name="emails" v-model="orgEdit.emails"></form-checkbox>
              <form-checkbox label="Chat" name="chat" v-model="orgEdit.chat"></form-checkbox>
              <form-checkbox label="Inventory" name="inventory" v-model="orgEdit.inventory"></form-checkbox>
              <br>
              <div class="form-group">
                <button v-on:click="cancelEdit" type="button" class="btn  btn-default">Cancel</button>
                <button v-on:click="submitEdit" type="button" class="btn  btn-success">Submit</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <showqrcode name="showQRCodeModal" :orgid="org['.key']"></showqrcode>

  </div>
</template>

<script>
import Vue from 'vue';
import VeeValidate from 'vee-validate';
import VueMask from 'v-mask'
import FormText from '../../elements/Form/FormText'
import FormTextMask from '../../elements/Form/FormTextMask'
import FormTextArea from '../../elements/Form/FormTextArea'
import database from '../../webmaster/Database/database'
import ShowQRCodeModal from './ShowQRCodeModal'

import EnabledFormCheckbox from '../../elements/Form/EnabledFormCheckbox'

Vue.use(VueMask);
Vue.use(VeeValidate);

export default {
  name: 'organizationdetail',
  components:{
    'form-text':FormText,
    'form-textarea':FormTextArea,
    'form-checkbox': EnabledFormCheckbox,
    'showqrcode': ShowQRCodeModal,
  },
  data () {
    return {
      org: {},
      orgEdit:{},
      isEditing: false
    }
  },
  created:function(){
    this.fetchOrg()
  },
  methods: {
    edit: function(){
      this.isEditing = true;
    },
    cancelEdit: function(){
      this.isEditing = false;
    },
    submitEdit: function(){
      let promises = [];
      var self = this;
      for (let child in this.$refs) promises.push(this.$refs[child].$validator.validateAll());
      Promise.all(promises).then(this.$validator.validateAll()).then(() => { 
        this.updateOrgData(database.getDb().ref(), self.orgEdit[".key"], self.orgEdit.name, self.orgEdit.description, self.orgEdit.emails, self.orgEdit.chat, self.orgEdit.inventory).then(_ => {
          this.org = Object.assign({}, this.org, this.orgEdit);
          self.isEditing = false;
        }).catch(err => {
          console.log(err)
        });
      }, () => {});
    },
    fetchOrg: function(){
      this.$bindAsObject('org', database.getRef('/meta_orgs/' + this.$route.params.id), null, function(){
        this.orgEdit = Object.assign({}, this.orgEdit, this.org);
      });
    },
    updateOrgData: function(rootRef, id, name, description, emails, chat, inventory){
      const orgUsers = database.getRef('/orgs/' + id + '/users')
      return orgUsers.once('value').then(snap => {
        let userKeys = Object.keys(snap.val());
        let updateObj = {}
        userKeys.forEach(key => {
          updateObj['/users/' + key + '/orgs/' + id + '/name'] = name
        });
        //Update org
        updateObj['/orgs/' + id + '/name'] = name
        updateObj['/orgs/' + id + '/description'] = description
        updateObj['/meta_orgs/' + id + '/name'] = name
        updateObj['/meta_orgs/' + id + '/description'] = description
        updateObj['/meta_orgs/' + id + '/emails'] = emails || false
        updateObj['/meta_orgs/' + id + '/chat'] = chat || false
        updateObj['/meta_orgs/' + id + '/inventory'] = inventory || false

        return rootRef.update(updateObj)
      });
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// OrganizationDetail.vue?0bb06513